<template>
  <table class="table-sm" style="width: 100%; background: #95b4ff30">
    <thead>
      <tr>
        <th nowrap class="text-center border-gray" width="28%">Campo</th>
        <th nowrap class="text-center border-gray" width="36%">Valor antigo</th>
        <th nowrap class="text-center border-gray" width="36%">Valor novo</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(value, index) in displayFields" :key="index">
        <td :title="audit.id" class="border-gray">
          {{ getFieldLabel(index, audit.type) }}
        </td>
        <td class="text-center border-gray">
          {{
            typeof audit.old_values != 'undefined' && index != 'change_reason'
              ? getValue(audit.old_values[index], index)
              : '-'
          }}
        </td>
        <td class="text-center border-gray">
          {{ typeof value != 'undefined' ? getValue(value, index) : '-' }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'CustomerContractPlanHistoryValuesTable',
  props: {
    audit: {
      type: Object,
    },
  },
  methods: {
    getFieldLabel(index, type) {
      const defaultFields = {
        product_id: 'Produto',
        customer_id: 'Cliente',
        finish: 'Fim do contrato',
        start: 'Início do contrato',
        actual_contract_date: 'Data atual do Contrato',
        note: 'Observações',
        billing_method: 'Cobrar por',
        due_day: 'Dia vencimento',
        contract_type: 'Tipo contrato',
        due_in_days: 'Prazo de vencimento',
        price: 'Preço',
        amount: 'Quantidade',
        datas: 'Faixas, Valor mínimo, etc',
        change_reason: 'Motivo da alteração',
        hired_by: 'Contratado por',
        grace_date: 'Data de carência',
        plan_id: 'Plano',
        note_chatbot: 'Informações chatbot',
        status: 'Status',
      };
      return defaultFields[index] + (type ? ` - ${type}` : '');
    },

    getValue(value, index) {
      if (
        typeof value !== 'undefined' &&
        value != '0000-00-00' &&
        (index == 'finish' || index == 'start' || index == 'grace_date' || index == 'actual_contract_date')
      ) {
        return value ? this.$options.filters.date(value) : '-';
      }

      if (typeof value !== 'undefined' && index == 'price') {
        return value ? this.$options.filters.money(value) : '-';
      }

      if (typeof value !== 'undefined' && index == 'contract_type') {
        return value == 1 ? 'Legado' : value == 2 ? 'TC' : 'PME';
      }

      if (typeof value !== 'undefined' && index == 'billing_method') {
        return value == 1 ? 'Carteira' : 'CNPJ';
      }

      if (typeof value !== 'undefined' && index == 'hired_by') {
        return value == 1 ? 'Termo' : 'Contrato';
      }

      if (value && index == 'datas') {
        value = value.replace('"billing_type":1', 'Faixa Simples');
        value = value.replace('"billing_type":2', 'Faixa Acumulada');
        value = value.replace('"charge_use_only":0', 'Cobrar todos usuários');
        value = value.replace('"ranges"', 'Faixas');
      }

      if (index == 'status') {
        switch (value.toString()) {
          case '2':
            return 'Ativo';
          case '1':
            return 'Bloqueado';
          case '0':
            return 'Suspenso';
          default:
        }
      }

      return value || '-';
    },
  },
  computed: {
    displayFields() {
      const filterFields = ['type_id', 'id', 'contract_id', 'service_id'];
      for (const [key, value] of Object.entries(this.audit.new_values)) {
        if (filterFields.includes(key)) {
          delete this.audit.new_values[key];
        }
      }
      return this.audit.new_values;
    },
  },
};
</script>
